<div *ngIf="tooltipHtml; else txt" [innerHTML]="tooltipHtml"></div>
<ng-template #txt>{{ tooltipText }}</ng-template>
